import React, { Component } from "react";
import { Link } from "react-router-dom";

import getOrderStatus from "../../../lib/getOrderStatus";

import DeliveredBy from "../../Common/DeliveredBy";
import getEstimatedTime from "../../../lib/getRecentEstimationTime";

export default class RecentListItem extends Component {
  render() {
    const {
      order,
      handleOpenOrderSection,
      pathname,
      search,
      onClickDeliveredBy
    } = this.props;
    const estimatedTime = getEstimatedTime(
      order.orderEarliestDeliveryDeadline,
      order.orderLatestDeliveryDeadline
    );
    const statusText = getOrderStatus(order.status, order.deliveryType);
    return (
      <Link
        to={{
          pathname,
          search,
          hash: `${order.uid}`
        }}
      >
        <div
          className="recent-order mt-10px cursor-pointer"
          onClick={() => handleOpenOrderSection(order.uid)}
        >
          <div className="row status hide-xs">
            <div className="col-sm-4 left">
              <div className="white-bg">
                <div>
                  <p> #{order.uid}</p>
                  <h4>{statusText}</h4>
                </div>
              </div>
            </div>
            {/* .left */}

            <div className="col-sm-8 right">
              <div className="white-bg d-flex align-items-center justify-content-between">
                <div>
                  <p>{order.restaurant.name}</p>
                  <div className="d-flex align-items-center mt-10px mb-10px">
                    <p className="mr-1">
                      £{parseFloat(order.total).toFixed(2)}
                    </p>
                    <p className="bold">+{order.earnedPoints} eCoins</p>
                  </div>
                  {estimatedTime && (
                    <p className="est-time">
                      Estimated delivery time {estimatedTime}
                    </p>
                  )}
                  {order.restaurant.deliveryType === "IN_HOUSE_DELIVERY" && (
                    <DeliveredBy
                      deliveryType={order.restaurant.deliveryType}
                      onClick={event =>
                        onClickDeliveredBy(event, order.restaurant.name)
                      }
                      name={order.restaurant.name}
                    />
                  )}
                </div>
                <div>
                  <a href="" className="btn">Order Details »</a>
                </div>
              </div>
            </div>
            {/* .right */}
          </div>
          {/* .status */}

          <div className="d-flex justify-content-between visible-xs">
            <div className="left">
              <h5>{statusText}</h5>
              <div>
                <p>{order.restaurant.name}</p>
                <div className="price">
                  <p>£{parseFloat(order.total).toFixed(2)}</p>
                  <p className="bold">+{order.earnedPoints} eCoins</p>
                </div>
              </div>
              {estimatedTime && (
                <p className="est-time">
                  Estimated delivery time {estimatedTime}
                </p>
              )}
              {order.restaurant.deliveryType === "IN_HOUSE_DELIVERY" && (
                <DeliveredBy
                  deliveryType={order.restaurant.deliveryType}
                  onClick={event =>
                    onClickDeliveredBy(event, order.restaurant.name)
                  }
                  name={order.restaurant.name}
                />
              )}
            </div>

            <a href="javascript: void(0)" className="bold">
              #{order.uid}
            </a>
          </div>
        </div>
      </Link>
    );
  }
}
